export class UserModel {
  userId?: number
  userName: string = ''
  avatar: string = ''
  choose?: boolean = false
  constructor(init?: Partial<UserModel>) {
    Object.assign(this, init)
  }
}
